/* eslint-disable max-classes-per-file */
 

import { CONCEPTS } from '@rover/rsdk/src/concepts';
import type { ConsentPurpose } from '@rover/rsdk/src/modules/Analytics';
import { AnalyticsEvent } from '@rover/types/src/Analytics';

type FieldName = 'pet_type' | 'service' | 'location' | 'dates' | 'add_more_details' | 'breed';

abstract class ColorfulPerfectMatchEvent extends AnalyticsEvent {
  abstract eventName: string;

  consentPurpose: ConsentPurpose = 'performance';

  concept = CONCEPTS.recommendations.browse_search;
}

export class ColorfulPerfectMatchSectionViewed extends ColorfulPerfectMatchEvent {
  eventName = 'colorful-perfect-match-section-viewed';
}

export class ColorfulPerfectMatchFieldInteraction extends ColorfulPerfectMatchEvent {
  eventName = 'colorful-perfect-match-field-interaction';

  constructor(eventProperties: { field: FieldName }) {
    super(eventProperties, { field: eventProperties.field });
  }
}

export class ColorfulPerfectMatchSearchTap extends ColorfulPerfectMatchEvent {
  eventName = 'colorful-perfect-match-search-tap';
}

export class ColorfulPerfectMatchBreedSelectorInteraction extends ColorfulPerfectMatchEvent {
  eventName = 'colorful-perfect-match-breed-selector-interaction';

  constructor(eventProperties: { breeds: string[] }) {
    super(eventProperties, { breeds: eventProperties.breeds });
  }
}
